import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_TEMPLATE_SECTION_FIELD_LIST =
  "GET_TEMPLATE_SECTION_FIELD_LIST";

export const service = async (data) => {
  const reportTemplateId = parseInt(data.reportTemplateId);
  const options: object = {
    url:
      `/Api/ReportTemplate/GetReportTemplateSectionFieldList?reportTemplateId=` +
      reportTemplateId,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_TEMPLATE_SECTION_FIELD_LIST, service, mock);
